import {
  Dashboard as DashboardIcon,
  ConfirmationNumber as TicketIcon,
  People as AdminIcon,
  LocationCity as BranchIcon,
  Assessment as ReportIcon,
  Settings as SettingsIcon,
  Person as ProfileIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GroupIcon from "@mui/icons-material/Group";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
// Navigation item types
export const NAV_TYPES = {
  SINGLE: "single",
  PARENT: "parent",
  CHILD: "child",
};

// User roles for access control
export const USER_ROLES = {
  ADMIN: "admin",
  USER: "user",
  BRANCH_ADMIN: "branch_admin",
  // Add more roles as needed
  // MANAGER: 'manager',
  // SUPERVISOR: 'supervisor',
  // OPERATOR: 'operator'
};

// Navigation configuration
export const navigationConfig = [
  {
    id: "dashboard",
    name: "Dashboard",
    path: "/",
    icon: DashboardIcon,
    type: NAV_TYPES.SINGLE,
    tooltip: "Dashboard",
    allowedRoles: [], // Empty means all roles can access
  },
  // {
  //   id: "tickets",
  //   name: "Tickets",
  //   path: "/tickets",
  //   icon: TicketIcon,
  //   type: NAV_TYPES.PARENT,
  //   tooltip: "Tickets",
  //   allowedRoles: [], // Empty means all roles can access
  //   children: [
  //     {
  //       id: "tickets-all",
  //       name: "All Tickets",
  //       path: "/tickets",
  //       type: NAV_TYPES.CHILD,
  //       allowedRoles: [],
  //     },
  //     {
  //       id: "tickets-new",
  //       name: "Create Ticket",
  //       path: "/tickets/new",
  //       type: NAV_TYPES.CHILD,
  //       allowedRoles: [],
  //       icon: AddIcon,
  //     },
  //   ],
  // },
  {
    id: "users",
    name: "ຜູ້ໃຊ້",
    path: "/users",
    icon: AdminIcon,
    type: NAV_TYPES.PARENT,
    tooltip: "ຜູ້ໃຊ້",
    allowedRoles: USER_ROLES.ADMIN,
    children: [
      {
        id: "user-all",
        name: "ຜູ້ໃຊ້ທັງໝົດ",
        path: "/users",
        type: NAV_TYPES.CHILD,
        allowedRoles: USER_ROLES.ADMIN,
      },
      {
        id: "users-new",
        name: "ເພີ່ມຜູ້ໃຊ້",
        path: "/users/new",
        type: NAV_TYPES.CHILD,
        allowedRoles: USER_ROLES.ADMIN,
        icon: AddIcon,
      },
    ],
  },
  {
    id: "checkpoints",
    name: "ຈຸດຮັບຝາກ",
    path: "/checkpoints",
    icon: BranchIcon,
    type: NAV_TYPES.PARENT,
    tooltip: "ຈຸດຮັບຝາກ",
    allowedRoles: [],
    children: [
      {
        id: "checkpoints-all",
        name: "ຈຸດຮັບຝາກທັງໝົດ",
        path: "/checkpoints",
        allowedRoles: [],

        type: NAV_TYPES.CHILD,
      },
      {
        id: "checkpoints-new",
        name: "ເພີ່ມຈຸດຮັບຝາກ",
        path: "/checkpoints/new",
        type: NAV_TYPES.CHILD,
        icon: AddIcon,
        allowedRoles: [],
      },
    ],
  },
  {
    id: "tickets",
    name: "ລາຍການປີ້ລົດ",
    path: "/tickets",
    icon: ReportIcon,
    type: NAV_TYPES.SINGLE,
    tooltip: "ປີ້ລົດ",
  },
  {
    id: "reports",
    name: "ລາຍງານ",
    path: "/reports",
    icon: ReportIcon,
    type: NAV_TYPES.PARENT,
    tooltip: "Reports",
    allowedRoles: USER_ROLES.ADMIN,
    children: [
      {
        id: "report_carIN_carOut",
        name: "ລາຍງານລົດເຂົ້າ - ອອກ",
        path: "/reports/car-in-car-out",
        icon: DirectionsCarIcon,
        allowedRoles: [],
        type: NAV_TYPES.CHILD,
      },
      // {
      //   id: "report_checkpoints",
      //   name: "ລາຍງານຈຸດຮັບຝາກທັງໝົດ",
      //   path: "/reports/checkpoints",
      //   icon: LocationOnIcon,
      //   type: NAV_TYPES.CHILD,
      //   allowedRoles: [],
      // },
      // {
      //   id: "report_users",
      //   name: "ລາຍງານຂໍ້ມູນຜູ້ໃຊ້ລະບົບ",
      //   path: "/reports/users",
      //   icon: GroupIcon,
      //   type: NAV_TYPES.CHILD,
      //   allowedRoles: [],
      // },
      // {
      //   id: "report_lostTicket",
      //   name: "ລາຍການປີ້ເສຍ",
      //   path: "/reports/lostTicket",
      //   icon: ReportProblemIcon,
      //   type: NAV_TYPES.CHILD,
      //   allowedRoles: [],
      // },
    ],
  },
];

// User settings navigation (separate section)
export const userNavigationConfig = [
  {
    id: "profile",
    name: "Profile",
    path: "/profile",
    icon: ProfileIcon,
    type: NAV_TYPES.SINGLE,
    tooltip: "Profile",
  },
  {
    id: "settings",
    name: "Settings",
    path: "/settings",
    icon: SettingsIcon,
    type: NAV_TYPES.SINGLE,
    tooltip: "Settings",
  },
];

// Helper functions for navigation
export const getNavigationByRole = (userRole) => {
  return navigationConfig
    .filter((item) => {
      // If no allowedRoles specified, item is accessible to all roles
      if (!item.allowedRoles || item.allowedRoles.length === 0) {
        return true;
      }
      // Check if user role is in allowed roles
      return item.allowedRoles.includes(userRole);
    })
    .map((item) => {
      // If item has children, filter them too
      if (item.children) {
        const filteredChildren = item.children.filter((child) => {
          if (!child.allowedRoles || child.allowedRoles.length === 0) {
            return true;
          }
          return child.allowedRoles.includes(userRole);
        });

        return {
          ...item,
          children: filteredChildren,
        };
      }

      return item;
    });
};

export const getNavigationItemById = (id) => {
  // Search in main navigation
  for (const item of navigationConfig) {
    if (item.id === id) return item;
    if (item.children) {
      const child = item.children.find((child) => child.id === id);
      if (child) return child;
    }
  }

  // Search in user navigation
  return userNavigationConfig.find((item) => item.id === id);
};

export const getParentByChildPath = (path) => {
  return navigationConfig.find(
    (item) =>
      item.children && item.children.some((child) => child.path === path)
  );
};

export const getAllPaths = () => {
  const paths = [];

  // Add main navigation paths
  navigationConfig.forEach((item) => {
    paths.push(item.path);
    if (item.children) {
      item.children.forEach((child) => paths.push(child.path));
    }
  });

  // Add user navigation paths
  userNavigationConfig.forEach((item) => paths.push(item.path));

  return paths;
};

export const isPathInSection = (currentPath, sectionPath) => {
  return currentPath.includes(sectionPath);
};

export const shouldShowCollapseIcon = (item) => {
  return (
    item.type === NAV_TYPES.PARENT && item.children && item.children.length > 0
  );
};

// Default export for easier importing
export default {
  navigationConfig,
  userNavigationConfig,
  NAV_TYPES,
  USER_ROLES,
  getNavigationByRole,
  getNavigationItemById,
  getParentByChildPath,
  getAllPaths,
  isPathInSection,
  shouldShowCollapseIcon,
};
